import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * A utility function for constructing className strings conditionally
 * and merging Tailwind CSS classes without style conflicts.
 * 
 * @param inputs - Class values to be processed
 * @returns Merged className string
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
} 